import styled from 'styled-components'

export const Content = styled.div`
  background: ${props => props.theme.palette.general.light};
`
